import Typography from '@material-ui/core/Typography';
import React from 'react';
import styled from 'styled-components';
import { ReactComponent as CrownGB } from '../icons/GB_Icon.svg';

interface CustomizableWheelProps {
    showText?: string;
}

export const CustomizableWheel = ({ showText }: CustomizableWheelProps) => (
    <Placeholder>
        <CrownGB className={'icon'} />
        {showText ? (
            <Typography style={{ marginLeft: 6 }} variant={'caption'}>
                {showText}
            </Typography>
        ) : null}
    </Placeholder>
);

const Placeholder = styled('div')`
    background-color: rgba(255, 255, 255, 0.7);
    padding: 2px 12px 2px 4px;
    border-radius: 15px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    font-weight: 500;
    font-size: 10px;
    display: flex;
    align: center;
    justify-content: start;

    .icon {
        height: 18px;
    }
`;

CustomizableWheel.defaultProps = {
    showText: 'Customizable',
};
